<div
  class="ancillary-bundle-selection flex flex--column"
  [attr.data-testid]="'ancillary-bundle-selection-' + category()"
>
  <fcom-product-card
    [originalPrice]="product()?.originalPrice | finNonZeroAmount: hideZeroPrices() | finPrice | finEmpty: ''"
    [title]="product()?.title"
    [detailText]="product()?.description | finStripHtml | finEmpty: ''"
    [showDetailText]="true"
    [hideButton]="true"
    [image]="product()?.image"
    [productTags]="product()?.productTags ?? []"
    [useNewProductCardLayout]="true"
    [variant]="ProductCardVariant.SECONDARY"
  />

  <hr class="ms-xxlarge-y nordic-blue-100-border border-primary" aria-hidden="true" />

  @for (notification of notifications(); track notification.key; let last = $last) {
    <fcom-notification
      [attr.data-testid]="'combo-notification-' + notification.theme"
      [class.pr-medium-b]="last"
      [class.pr-xxsmall-b]="!last"
      [theme]="notification.theme"
      [iconName]="notification.iconName"
    >
      @if (notification.key | finHasLocalizationKey) {
        <span [innerHTML]="notification.key | finLocalization | finSafe: 'html'"></span>
      }
      @if (notification.reason) {
        <span
          [innerHTML]="notification.reason.key | finLocalization: notification.reason.data | finSafe: 'html'"
        ></span>
      }
    </fcom-notification>
  }

  @if (!selectionBlocked()) {
    @let bundleConstituents = constituents();
    @let availability = availabilityByPax();
    @let selections = selectionsByPax();
    @let tierBenefit = tierBenefitByPax();
    @for (passenger of passengers(); track passenger.id) {
      <fin-bundle-offer-card
        class="ms-large-b"
        [passenger]="passenger"
        [category]="category()"
        [fragmentId]="flight().id"
        [constituents]="bundleConstituents"
        [availability]="availability[passenger.id] ?? null"
        [selectedForPassenger]="!!selections[passenger.id]"
        [isBundleAncillariesIncludedInTier]="tierBenefit[passenger.id] ?? false"
        (addCombo)="addCombo(passenger)"
        (removeCombo)="removeCombo(passenger)"
      />
    }
  }
</div>
